var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "a-row",
          { staticStyle: { "margin-top": "15px" }, attrs: { gutter: 24 } },
          [
            _c(
              "a-col",
              {
                staticClass: "title-1 title-margin flex-between",
                attrs: { span: 24 },
              },
              [_c("div", [_vm._v("学校试用情况：")])]
            ),
          ],
          1
        ),
        _c("a-card", { attrs: { bordered: true } }, [
          _c(
            "div",
            { staticClass: "table-operator" },
            [
              _c(
                "a-button",
                {
                  attrs: { type: "primary", icon: "plus" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("a-table", {
                ref: "table",
                staticClass: "j-table-force-nowrap",
                attrs: {
                  size: "middle",
                  bordered: "",
                  rowKey: (record, index) => index + "_" + record.id,
                  columns: _vm.columns,
                  dataSource: _vm.dataSource,
                  pagination: _vm.ipagination,
                  loading: _vm.loading,
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "freeOpenSlot",
                    fn: function (text, record) {
                      return [
                        _c("a-switch", {
                          attrs: { checked: !!text },
                          on: {
                            change: function ($event) {
                              return _vm.changetrialOpenFlag(record.id, text)
                            },
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "action",
                    fn: function (text, record) {
                      return _c("span", {}, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(record)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _c("school-config-modal", {
          ref: "modalForm",
          on: { ok: _vm.modalFormOk },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }